import React from 'react'
import Icon from 'react-icon-base'

import styles from '../../../v1/components/filters/filterGroup/index.module.css'

export default props => {
  return (
    <Icon viewBox="0 0 18 18" {...props}>
      <g className={styles.barTop} fill="#333333">
        <rect x="0" y="3" width="18" height="2" />
      </g>
      <g className={styles.barMiddle} fill="#333333">
        <rect x="0" y="8" width="18" height="2" />
      </g>
      <g className={styles.barBottom} fill="#333333">
        <rect x="0" y="13" width="18" height="2" />
      </g>

      <g className={styles.controlTop}>
        <g>
          <circle fill="#333333" cx="4.5" cy="4" r="2.2" />
          <circle fill="#FFFFFF" cx="4.5" cy="4" r="0.8" />
        </g>
      </g>
      <g className={styles.controlMiddle}>
        <g>
          <circle fill="#333333" cx="13.5" cy="9" r="2.2" />
          <circle fill="#FFFFFF" cx="13.5" cy="9" r="0.8" />
        </g>
      </g>
      <g className={styles.controlBottom}>
        <g>
          <circle fill="#333333" cx="9" cy="14" r="2.2" />
          <circle fill="#FFFFFF" cx="9" cy="14" r="0.8" />
        </g>
      </g>
    </Icon>
  )
}
